var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgArrowLeftRightFill = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: 16,
    height: 16,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0503 12.0498L21 16.9996L16.0503 21.9493L14.636 20.5351L17.1716 17.9996H4V15.9996H17.1716L14.636 13.464L16.0503 12.0498ZM7.94975 2.0498L9.36396 3.46402L6.82843 5.99955H20V7.99955H6.82843L9.36396 10.5351L7.94975 11.9493L3 6.99955L7.94975 2.0498Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowLeftRightFill, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-left-right-fill.f71bb746.svg";
export { ForwardRef as ReactComponent };